module.exports = "/static/assets/25cd71063469498df7cab179156d87b2.png";